<template>
  <div>
    <div class="text-xs leading-none font-medium break-all text-gray-500 md:text-base">
      <div data-test="dashboard-title-activityfeed">
        <slot />
      </div>
    </div>
  </div>
</template>
